export const mergeHeaders = (
  defaults: HeadersInit,
  overrides?: HeadersInit
): Record<string, string> => {
  const headers = new Headers(defaults);

  for (const [name, value] of new Headers(overrides)) {
    headers.set(name, value);
  }

  return Object.fromEntries(headers.entries());
};
